import type { KubernetesHost } from './host';
import { createKubernetesRoutes } from './route';
import { serviceScopes } from './service';
import { workspaceServiceFor } from './v2/workspace-service';

/**
 * The module for the app to mount: its two services-hub routes (v1 and v2), its catalog scope and the
 * loaders of the three things other pages render outside its consoles (the activation landing of the
 * catalog detail page, and the cluster list and cluster picker the Organizations console shows). Plain
 * data and functions; the consoles stay lazy chunks behind `route.ts`. The host is a lazy factory, not
 * a value: the app file that builds it imports hooks the entry chunk does not need, so it is fetched
 * when a route (or a loader) runs and registered before any code of the module runs. Taking it is the
 * only way to get the routes, so the app cannot mount the module and forget what it reads.
 */
export function createKubernetesModule(loadHost: () => Promise<KubernetesHost>, options: { v2Enabled: boolean }) {
  const routes = createKubernetesRoutes(loadHost, options);
  return {
    servicesRoutes: routes.servicesRoutes,
    loadActivateLanding: routes.loadActivateLanding,
    loadProjectClusters: routes.loadProjectClusters,
    loadClusterScopePicker: routes.loadClusterScopePicker,
    serviceScopes,
    workspaceService: workspaceServiceFor(options.v2Enabled),
  };
}

export type { KubernetesHost } from './host';
